:host {
  .phone2 {
    padding-bottom: 1px;
    &__container {
      .support-ik {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        span {
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          color: var(--font-primary);
        }
      }

      .phone-block {
        background: white;
        background: var(--bg-primary);
        border-radius: 10px;
        padding: 24px;
        margin-bottom: 16px;

        &__title {
          display: flex;
          align-items: baseline;
          gap: 8px;
          margin-bottom: 18px;
          div {
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            color: var(--font-primary);
          }
          .central-state {
            font-size: 14px;
            font-weight: 400;
            color: #3ebf4d;
            .dot {
              margin-right: 6px;
              height: 10px;
              width: 10px;
              background-color: #3ebf4d;
              border-radius: 50%;
              display: inline-block;
            }
            &.disabled {
              color: #f44336;
              .dot {
                background-color: #f44336;
              }
            }
          }
        }

        &__opening-time {
          display: flex;
          gap: 16px;
          div {
            display: flex;
            gap: 6px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            color: var(--font-secondary);
            margin-bottom: 18px;
          }
        }

        &__stats-block {
          padding: 16px;
          border-radius: 4px;
          border: 1px solid #e3e3e3;
          margin-bottom: 18px;
          .header {
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 48px;
            &__awaiting-time {
              font-size: 14px;
              font-weight: 500;
              color: #333333;
              color: var(--font-primary);
            }
            &__timer {
              font-size: 24px;
              font-weight: 500;
              color: #0098ff;
              span {
                font-size: 16px;
                font-weight: 500;
              }
            }
            &__support-premium-ad {
              margin-top: 24px;
            }
            &__close-text {
              font-size: 14px;
              font-weight: 500;
              color: #333333;
              color: var(--font-primary);
              strong {
                display: block;
                text-align: center;
                margin-top: 8px;
                font-weight: 500;
                font-size: 16px;
                color: #f44336;
              }
            }
          }
        }

        &__support-contact {
          margin-bottom: 18px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          .contact-line {
            order: 0;
            font-size: 12px;
            font-weight: 500;
            color: #333333;
            color: var(--font-primary);
            margin: 0;
            span {
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              color: var(--font-secondary);
            }
          }
          .contact-info {
            order: 1;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            background: #f5f5f5;
            background: var(--bg-secondary);
            border-radius: 4px;
            justify-content: space-around;
            padding: 12px 8px;
            white-space: nowrap;
            gap: 8px;
            @media screen and (max-width: 480px) {
              flex-direction: column;
            }
            .container {
              display: flex;
              align-items: center;
              @media screen and (max-width: 480px) {
                flex-direction: column;
                align-content: center;
              }
              .number {
                padding-right: 8px;
                border-right: 1px solid var(--divider, #e0e0e0);
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                color: #333333;
                color: var(--font-primary);
                @media screen and (max-width: 480px) {
                  border: none;
                  align-content: center;
                }
              }
              .vip-code {
                display: flex;
                align-items: center;
                gap: 8px;
                padding-left: 8px;
                font-size: 12px;
                font-weight: 400;
                color: #666666;
                color: var(--font-secondary);
                white-space: normal;
                & > span {
                  font-size: 14px;
                  font-weight: 500;
                  color: #333333;
                  color: var(--font-primary);
                }
              }
            }
            .phone-block__call-action {
              a button.not-highlight {
                background: transparent;
                color: var(--blue);
                border: 1px solid var(--blue);
              }
            }
            &.not-vip {
              .number {
                padding-right: 0;
                border-right: unset;
              }
              .vip-code {
                display: none;
              }
            }

            @media screen and (max-width: 480px) {
              flex-direction: column;
              .number {
                padding-right: 0;
                border-right: unset;
              }
              .vip-code {
                padding-left: 0;
                margin-top: 8px;
              }
            }
          }
          div.highlight {
            order: 5 !important;
          }

          .callmeback {
            border-radius: 4px;
            padding: 12px 16px;
            text-align: center;
            font-size: 14px;
            justify-content: center;
            min-height: 44px;
          }

          button.highlight {
            background: var(--blue, #0098ff);
            color: var(--bg-primary, #fff);
          }

          button.disable {
            background: var(--bg-secondary, #f5f5f5);
            color: #9f9f9f;
            cursor: not-allowed;
            .tooltiptext {
              text-transform: none;
              text-align: left;
              color: #f5f5f5;
              font-size: 14px;
              right: unset;
              left: 50%;
              translate: -50%;
              text-wrap: wrap;
              max-width: 410px;
              &::after {
                right: unset;
                left: 50%;
                translate: -50%;
                margin-left: 0;
              }
            }
          }

          .callmeback {
            order: 2;
          }
        }

        &__call-action {
          a {
            button {
              min-width: 160px;
              width: 100%;
              padding: 12px 16px;
              border: 0;
              border-radius: 4px;
              font-size: 14px;
              font-weight: 400;
              background-color: #0098ff;
              color: #fff;
            }
            &.disabled {
              cursor: not-allowed;
              button {
                background-color: #e0e0e0;
                color: #9f9f9f;
              }
            }
          }
        }

        &__code-authorization {
          border-bottom: 1px solid #e3e3e3;
          padding-bottom: 18px;
          margin-bottom: 18px;
          .code-line {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            color: var(--font-primary);
            margin-bottom: 8px;
          }
          .code-info {
            display: flex;
            align-items: center;
            padding: 1px 8px;
            width: fit-content;
            background: #f5f5f5;
            background: var(--bg-secondary);
            border-radius: 4px;
            div {
              font-weight: 500;
              color: #333333;
              color: var(--font-primary);
              margin-right: 8px;
            }
          }
        }

        &__access-authorization {
          .access-line {
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            color: var(--font-primary);
            margin-bottom: 8px;
          }

          .access-choice {
            display: flex;
            flex-direction: column;
            gap: 16px;
            width: 100%;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            .choices {
              display: flex;
              align-items: center;
              width: 100%;

              .choice__text {
                flex-basis: 33%;
                color: #333333;
                color: var(--font-primary);
                font-size: 14px;
                font-weight: 400;
                @media screen and (max-width: 550px) {
                  flex-basis: 48%;
                }
              }

              .choice__switch {
                input[type='checkbox'] {
                  height: 0;
                  width: 0;
                  visibility: hidden;
                  position: absolute;
                }

                label {
                  cursor: pointer;
                  text-indent: -9999px;
                  width: 36px;
                  height: 20px;
                  background: #e0e0e0;
                  background: var(--divider);
                  display: block;
                  border-radius: 24px;
                  position: relative;
                }

                label:after {
                  content: '';
                  position: absolute;
                  top: 2px;
                  left: 2px;
                  width: 16px;
                  height: 16px;
                  background: #fff;
                  border-radius: 10px;
                  transition: 0.3s;
                }

                input:checked + label {
                  background: #0098ff;
                  background: var(--blue);
                }

                input:checked + label:after {
                  left: calc(100% - 2px);
                  transform: translateX(-100%);
                }

                label:active:after {
                  width: 30px;
                }
              }
            }
          }
        }
      }
    }

    /* -------------------------------------------------------------------------- */
    /*                                  FULL MODE                                 */
    /* -------------------------------------------------------------------------- */
    &--full {
      .support-ik {
        span {
          color: white;
        }
      }
    }
  }

  .hide {
    display: none !important;
  }

  .tooltip {
    position: relative;
    display: flex;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    min-width: 250px;
    background-color: #333;
    background-color: var(--bg-tooltip);
    color: #f5f5f5;
    color: var(--font-tooltip);
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    padding: 10px;
    box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.15);
    margin-left: 0;
    right: -6px;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
  }

  .tooltip .tooltiptext::after {
    content: '';
    position: absolute;
    top: 100%;
    right: 10px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
    border-color: var(--bg-tooltip) transparent transparent transparent;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  /* -------------------------------------------------------------------------- */
  /*                                 RESPONSIVE                                 */
  /* -------------------------------------------------------------------------- */

  // Medium devices (tablets, 768px and up)
  @media (max-width: 768px) {
    .phone {
      .phone-authorization {
        width: 100%;

        &__choice {
          max-width: 350px;
        }
      }
    }
  }
}
